module.exports = __webpack_public_path__ + "img/weight-hanging.21d8fc70.svg";